import { render, staticRenderFns } from "./DashboardLoginsCard.vue?vue&type=template&id=683f4c0e"
import script from "./DashboardLoginsCard.vue?vue&type=script&lang=js"
export * from "./DashboardLoginsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports